// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2695a50d","453":"94e39df3","667":"44c5d9e0"}[chunkId] + ".chunk.js";
};